import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { MARK_ITEM } from '../../../BlankEditor/type';

export const MarkId = 'mark-element-id';

const MarkElement = styled.div`
  display: none;
`;
export const renderMarkElement =
  () =>
  ({ element }: RenderElementProps) => {
    if (element.type === MARK_ITEM) {
      return <MarkElement id={MarkId} />;
    }
    return null;
  };
